import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useRef, useState } from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";
import TimeLine from "../../common/components/TimeLine/TimeLine";
import SblcConfirm from "../../common/components/sblcComponent/SblcConfirm";
import RightSidebar from "../../common/components/RightSidebar/RightSidebar";
import FormA1Form from "../../common/FormA1Component/FormA1Form";
import Demo from "../../TestDemo/Demo";
import PLPassword from "../../common/components/plPassword/PLPassword";
import html2pdf from "html2pdf.js";

export default function FormA1() {
  const [isCount, setIsCount] = useState(3);
  // const formA1Ref = useRef([]);
  // const sectionsRef = useRef([]);
  // const page2Element = document.getElementById("formA1_Screen");
  // console.log("page2Element", page2Element);

  // const handleDownload = () => {
  //   const page2Element = document.getElementById("formA1_Screen");
  //   html2canvas(page2Element, { scale: 2 }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();
  //     const imgWidth = pdfWidth;

  //     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, pdfHeight);
  //     pdf.save("Form A1.pdf");
  //   });
  // };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <div className="col-12  col-lg-2 p-0">
            <Sidebar />
          </div>

          {/* Main Content Area */}
          <div className="col-12  col-lg-10">
            {/* Timeline Header */}
            <div className="row align-items-center">
              <div className="col-12 px-3 px-md-1 px-lg-1">
                <div className="headerTimeLine">
                  <TimeLine currentStep={isCount} />
                </div>
              </div>
            </div>

            {/* Form Body Section */}
            <div className="row px-3 px-md-4 px-lg-4 mt-2">
              {/* FormA1 Content */}
              <div className="col-12 col-lg-9 d-flex justify-content-center align-items-start mb-4 mb-lg-0">
                <div className="statusWaiverMainContainer w-100">
                  <div id="formA1_Screen" style={{ width: "100%" }}>
                    <FormA1Form />
                  </div>
                </div>
              </div>

              {/* Right Sidebar */}
              <div className="col-12 col-lg-3">
                <div className="right_sidebar">
                  <RightSidebar setIsCount={setIsCount} islabel="FORM A1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PLPassword />
    </>
  );
}
